module.exports = __webpack_public_path__ + "static/media/demo_results_1.b4315bcf.png";